import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalItem',
  emits: ['ok','open','close'],
  setup(__props, { emit }) {


const visible = ref<boolean>(false);
function open() {
  visible.value = true;
}
const loading = ref<boolean>(false);
function onLoading() {
  loading.value = !loading.value;
}
async function ok(e) {
  emit('ok', onLoading, callback);
  function callback() {
    loading.value = false;
    visible.value = false;
  }
}
watch(visible, (val) => {
    val?emit('open',val):emit('close', val);
});

return { __sfc: true,emit, visible, open, loading, onLoading, ok }
}

})